import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../core/config.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LocationStatusService {
  constructor(private configService: ConfigService,
              private httpClient: HttpClient) {
  }

  getNodesForLocation(locationId: string): any {
    const url = this.configService.getNodeUrl() + '/nodes/location/' + locationId;
    return this.httpClient.get(url).toPromise();
  }

  getNodeDataForNodes(nodes: any ) {
    const url = this.configService.getNodeDataUrl() + '/nodeData/nodes';
    return this.httpClient.post(url, nodes).toPromise();

  }

}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/location-status/location-status.service.ts